import React from 'react';

export const joinLastWordWithIcon = (text, icon) => {
    const textSplit = text.trim().split(" ");
    const lastWord = textSplit.pop();
    const lastWordWithIcon = <span className="text-wsp-nowrap">{lastWord} {icon}</span>;
    const textStart = textSplit.join(" ");
    return <>{textStart} {lastWordWithIcon}</>
}